import React from 'react';
import ReactDOM from 'react-dom';

export class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.initialOpen !== undefined ? props.initialOpen : false,
    }
  }

  componentDidMount() {
    if(this.state.open) {
      document.addEventListener('click', this.handleDocumentClick);      
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(!prevState.open && this.state.open) {
      document.addEventListener('click', this.handleDocumentClick);
    } else if (prevState.open && !this.state.open) {
      document.removeEventListener('click', this.handleDocumentClick);      
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
  }

  isDroppedDown = () => {
    return this.state.open;
  }

  setDroppedDown = (state) => {
    if(!state) {
      this.props.onClose && this.props.onClose();
    }
    this.setState({
      open: state,
    });
  }

	handleDocumentClick = (event) => {
		if(this.isDroppedDown()) {
			if(this.element && !ReactDOM.findDOMNode(this.element).contains(event.target)) {
				this.setDroppedDown(false);
			}
		}
	}

	handleOpenerClick = (event) => {
		if(!this.isDroppedDown()) {
			event.preventDefault();
			this.setDroppedDown(true);
		}
  }
  
  handleTogglerClick = (event) => {
    if(!this.isDroppedDown()) {
			event.preventDefault();
			this.setDroppedDown(true);
		} else {
      this.setDroppedDown(false);
    }
  }

	handleClose = (event) => {
		if(this.isDroppedDown()) {
			this.setDroppedDown(false);
		}
	}

	handleRef = (element) => {
		this.element = element;
	}

	render() {
		return this.props.children({
      isOpen: this.isDroppedDown(), 
      /* HACK to achieve toggling everywhere....*/
      //onOpen: this.handleOpenerClick, 
      onOpen: this.handleTogglerClick, 
      onOpenToggle: this.handleTogglerClick,
      onOpenOnly: this.handleOpenerClick,
			onClose: this.handleClose,
			ref: this.handleRef,
		});
	}
}


// WEBPACK FOOTER //
// ./src/visual/component/Dropdown.js